import styled, { keyframes, css } from "styled-components";
import { breakpoints } from "definitions";

/* El esqueleto se arma con los mismos bloques que el formulario en vez de con
   un SVG de coordenadas fijas: así no puede quedar dibujando un layout que ya
   no existe (era lo que hacía ver por un instante el diseño anterior). */

const shimmer = keyframes`
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
`;

const skeleton = css`
  background: linear-gradient(90deg, #f3f3f3 25%, #ecebeb 37%, #f3f3f3 63%);
  background-size: 300% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Bone = styled.div`
  ${skeleton};
  height: ${({ height }) => height || "1.2rem"};
  width: ${({ width }) => width || "100%"};
  border-radius: ${({ round }) => (round ? "50%" : "4px")};
`;

export const FieldBone = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 0;
`;

export const InputBone = styled.div`
  ${skeleton};
  height: 4.2rem;
  border-radius: 8px;
`;

export const GroupBone = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  + div {
    margin-top: 2.6rem;
  }
`;

export const RowBone = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns || 2}, minmax(0, 1fr));
  gap: 1.8rem 2.4rem;

  ${breakpoints.tablet} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const ProjectBone = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 1.6rem 2.4rem;
  align-items: start;

  ${breakpoints.tablet} {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
  }
`;

export const AvatarBone = styled.div`
  ${skeleton};
  width: 14rem;
  height: 14rem;
  border-radius: 50%;

  ${breakpoints.tablet} {
    width: 12rem;
    height: 12rem;
  }
`;
